import type { DragEvent, RefObject } from 'react'
import type {
  DataTableCellValue,
  DataTableColumn,
  DataTableInstance,
  DataTableRowData,
} from '../../types'
import { reorderColumn } from '../../utils/column.utils'
import { GrabHandleButton } from '../buttons/grab-handle-button'

interface Props<TData extends DataTableRowData, TValue = DataTableCellValue> {
  column: DataTableColumn<TData, TValue>
  table: DataTableInstance<TData>
  tableHeadCellRef: RefObject<HTMLTableCellElement>
}

export const TableHeadCellGrabHandle = <TData extends DataTableRowData>({
  column,
  table,
  tableHeadCellRef,
  ...rest
}: Props<TData>) => {
  const {
    getState,
    options: { enableColumnOrdering },
    setColumnOrder,
    setDraggingColumn,
    setHoveredColumn,
  } = table
  const { columnOrder, draggingColumn, hoveredColumn } = getState()

  const arg = { column, table }
  const actionIconProps = {
    ...arg,
    ...rest,
  }

  const handleDragStart = (event: DragEvent<HTMLButtonElement>) => {
    // @ts-ignore
    actionIconProps?.onDragStart?.(event)
    setDraggingColumn(column)
    event.dataTransfer.setDragImage(tableHeadCellRef.current as HTMLElement, 0, 0)
  }

  const handleDragEnd = (event: DragEvent<HTMLButtonElement>) => {
    // @ts-ignore
    actionIconProps?.onDragEnd?.(event)
    if (hoveredColumn?.id === 'drop-zone') {
      column.toggleGrouping()
    } else if (enableColumnOrdering && hoveredColumn && hoveredColumn?.id !== draggingColumn?.id) {
      setColumnOrder(reorderColumn(column, hoveredColumn as DataTableColumn<TData>, columnOrder))
    }
    setDraggingColumn(null)
    setHoveredColumn(null)
  }

  return (
    <GrabHandleButton
      // @ts-ignore
      actionIconProps={actionIconProps}
      onDragEnd={handleDragEnd}
      onDragStart={handleDragStart}
      table={table}
    />
  )
}
